<template>
  <div>
    <zhandian    > </zhandian> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import zhandian from '../../tongyong/zhandian.vue';
 
export default {

  components: {
    zhandian: zhandian 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
